import { FeaturesEnum } from '~/features/types';

export default [
  {
    path: '/corrective-actions',
    meta: {
      auth: true,
      feature: FeaturesEnum.CORRECTIVE_ACTIONS,
    },
    component: () => import('~/common/layouts/default.vue'),
    children: [
      {
        path: '',
        name: 'correctiveActions',
        component: () => import('~/correctiveActions/pages/Index.vue'),
      },
    ],
  },
];
